import React from "react";
import {
  CardBottomPanel,
  CardImage,
  CardWrapperLink,
  PostTitle,
  ReadingTime,
  GuidePostCategory,
} from "./style";

interface GhostArticlePostCardProps {
  cardTitle?: string | null | undefined;
  title: string;
  url: string;
  readingTimeLabel: string;
  imageUrl: string;
  isLastPost?: boolean;
  shouldAddBorderToImageContainer?: boolean;
  shouldAddBorderToLabelContainer?: boolean;
  cardWidth: string;
  cardHeight: string;
  imageWidth: string;
  imageHeight: string;
  imagePadding: string;
  imageObjectFit: string;
  imageBackgroundColor?: string;
}

const GhostArticlePostCard = ({
  cardTitle = null,
  title,
  url,
  readingTimeLabel,
  imageUrl,
  isLastPost = false,
  shouldAddBorderToImageContainer = false,
  shouldAddBorderToLabelContainer = false,
  cardWidth,
  cardHeight,
  imageWidth,
  imageHeight,
  imagePadding,
  imageObjectFit,
  imageBackgroundColor = "transparent",
}: GhostArticlePostCardProps) => (
  <CardWrapperLink
    to={{ pathname: url }}
    target="_blank"
    isLastPost={isLastPost}
    shouldAddBorder={shouldAddBorderToImageContainer && shouldAddBorderToLabelContainer}
    cardWidth={cardWidth}
    cardHeight={cardHeight}
  >
    <CardImage
      src={imageUrl}
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      imagePadding={imagePadding}
      imageObjectFit={imageObjectFit}
      imageBackgroundColor={imageBackgroundColor}
    />
    <CardBottomPanel shouldAddBorder={!shouldAddBorderToImageContainer && shouldAddBorderToLabelContainer}>
      {!!cardTitle && <GuidePostCategory>{cardTitle}</GuidePostCategory>}
      <PostTitle>{title}</PostTitle>
      <ReadingTime>{readingTimeLabel}</ReadingTime>
    </CardBottomPanel>
  </CardWrapperLink>
);

export default GhostArticlePostCard;
